/** Fisher–Yates partial shuffle; returns `count` distinct items from `pool`. */
export function pickRandomSuggestions<T>(pool: readonly T[], count: number): T[] {
  if (pool.length <= count) return [...pool];
  const copy = [...pool];
  for (let index = copy.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [copy[index], copy[swapIndex]] = [copy[swapIndex], copy[index]];
  }
  return copy.slice(0, count);
}
